import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ApiService, CacheService } from 'angular-lib';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { LoaderService } from '../../../services/loader.service';

@Component({
    selector: 'ez-search',
    template: require('./search.component.html'),
    styles: [require('./search.component.less')],
    encapsulation: ViewEncapsulation.None
})
export class SearchComponent implements OnInit {
    @ViewChild('sliderLocationRange') private sliderLocationRange: any;
    @ViewChild('sliderAgeRange') private sliderAgeRange: any;

    public genders: Object[];
    public locationRange: number = 0;
    public locationRangeStr: string = '';
    public ageRange = [18, 99];
    public ageRangeStr: string = '';
    public userLoaded = false;

    public rangeLocationConfig: any = {
        behaviour: 'snap',
        snap: true,
        range: {
            'min': 0,
            '10%': 25,
            '25%': 50,
            '50%': 100,
            '75%': 200,
            'max': 500,
        }
    };

    public rangeAgeConfig: any = {
        behaviour: 'snap'
    };

    public subs: Array<Observable<any>> = [];

    constructor(
        private apiService: ApiService,
        private translate: TranslateService,
        private loaderService: LoaderService
    ) {
    }

    public ngOnInit () {
        this.loaderService.show();

        this.ageRangeStr = this.ageRange.join(' - ');
        let miscConfig = this.apiService.miscConfig();
        miscConfig.subscribe(conf => {
            this.genders = conf.genders
        });
        this.subs.push(miscConfig);

        let sessionS = this.apiService.user();
        sessionS.subscribe(user => {
            if (typeof user.locationSearch !== 'undefined' && user.locationSearch.hasOwnProperty('range')) {
                this.locationRange = user.locationSearch.range;

                this.translate.get('profile.range-metrics').subscribe((str) => {
                    this.locationRangeStr = str.replace('{user-distance}', user.locationSearch.range);
                });
            }

            if (
                typeof user.baseSearch.data !== 'undefined' &&
                user.baseSearch.data.hasOwnProperty('ageMin') &&
                user.baseSearch.data.hasOwnProperty('ageMax')
            ) {
                this.ageRange = [user.baseSearch.data.ageMin, user.baseSearch.data.ageMax];
            }

            this.ageRangeStr = this.ageRange.join(' - ');
            this.userLoaded = true;
        },
            err => console.error('failed to get me ' + err.message),
        );
        this.subs.push(sessionS);

        Observable.forkJoin(this.subs).subscribe(
            res => {
                this.loaderService.hide();
            },
            error => {
                this.loaderService.hide();
            }
        );
    }

    public onChangeLocationRange(event) {
        this.translate.get('profile.range-metrics').subscribe((str) => {
            this.locationRangeStr = str.replace('{user-distance}', event);
        });
    }

    public onChangeAgeRange(event) {
        this.ageRangeStr = event.join(' - ');
    }

    public updateAgeRange(event) {
        if (this.userLoaded) {
            this.apiService.saveAgeRange(event[0], event[1]).subscribe((res) => {
                // refresh profil cache
                CacheService.remove(CacheService.LOGGED_USER);
                this.apiService.user().subscribe();
            });
        }
    }

    public updateLocationRange(event) {
        if (this.userLoaded) {
            this.apiService.saveLocationSearch({searchLocationRange: event}).subscribe((res) => {
                // refresh profil cache
                CacheService.remove(CacheService.LOGGED_USER);
                this.apiService.user().subscribe();
            })
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/profile/search/search.component.ts